export default __webpack_public_path__ + "static/media/red-envelope.aa8ef297.svg";